<div class="popup">
    <div class="popup_content">
        <div class="popup_content_heading">
            <h5 class="modal-title">
                {{title}}
            </h5>
        </div>
        <div class="popup_content_content">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div>
                    <div class="element_top form__field">
                        <label>{{Name}} <span class="star">*</span></label>
                        <mat-form-field appearance="fill" class="popup">
                            <input autocomplete="off" [type]="isPasswordField ? (showPassword ? 'text' : 'password') : 'text'" matInput formControlName="name"
                                [matAutocomplete]="auto" (ngModelChange)="listFilter($event)">
                            
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let option of filteredOptions" [value]="option"
                                    [hidden]="data.hideList">
                                    {{option}}
                                </mat-option>
                            </mat-autocomplete>
                        <button mat-icon-button *ngIf="isPasswordField" matSuffix type='button' tabindex='-1' (click)='togglePasswordVisibility()'><mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon></button></mat-form-field>
                        
                    </div>
                    <div *ngIf="isMapped && ((isFirstChecked && (title === 'Add Suites' || title === 'Add Scenario')) || (title === 'Edit Suites' || title === 'Edit Scenario'))"
                        (ngAfterViewInit)="showList()">
                        <p>Mapping with jira</p>
                        <div class="mapDiv firstmap">
                            <span>Jira {{jiratitle}} List</span>
                            <div *ngIf="title === 'Add Suites' || title === 'Edit Suites'">
                                <div *ngIf="isLoadingEpics" class="loading-message">
                                    Fetching list...
                                </div>
                                <select (change)="onSelectChange($event.target.value)"
                                    *ngIf="jiraEpicList && !isLoadingEpics">
                                    <option value="" selected>Select an option</option>
                                    <option *ngFor="let jiraEpic of jiraEpicList; let i = index" [value]="i">
                                        {{jiraEpic.epic_name}}</option>
                                    <option *ngIf="hasMoreEpics" value="loadMoreEpics" [disabled]="isLoadingEpics" class="load-more-option">
                                        {{ isLoadingEpics ? 'Loading...' : 'Load More' }}
                                    </option>
                                </select>
                                <p *ngIf="(!jiraEpicList || jiraEpicList.length === 0) && !isLoadingEpics" class="no-list-message nomassage">
                                    No list is present</p>
                            </div>
                            <div *ngIf="title === 'Add Scenario' || title === 'Edit Scenario'">
                                <div *ngIf="isLoadingIssues" class="loading-message">
                                    Fetching list...
                                </div>
                                <select (change)="onSelectIssueChange($event.target.value)"
                                    *ngIf="jiraIssueList && !isLoadingIssues">
                                    <option value="" selected>Select an option</option>
                                    <option *ngFor="let jiraIssue of jiraIssueList; let i = index" [value]="i">
                                        {{jiraIssue.issue_summary}}</option>
                                    <option *ngIf="hasMoreIssues" value="loadMoreIssues" [disabled]="isLoadingIssues" class="load-more-option">
                                        {{ isLoadingIssues ? 'Loading...' : 'Load More' }}
                                    </option>
                                </select>
                                <p *ngIf="(!jiraIssueList || jiraIssueList.length === 0) && !isLoadingIssues"
                                    class="no-list-message nomassage">No list is present</p>
                            </div>
                        </div>
                    </div>
                    <div class="element_box">
                        <div class="elememnt_error">
                            <mat-error *ngIf="form.get('name').hasError('required')">{{Name}} is required</mat-error>
                            <div class="mat-error ng-star-inserted element"
                                *ngIf="form.get('name').hasError('duplicate') || isDuplicate">
                                {{data.duplicateMessage?data.duplicateMessage:"please enter unique name or use older one
                                directly"}}</div>
                            <div class="mat-error ng-star-inserted element"
                                *ngIf="form.get('name').hasError('pageDuplicate') || isPageDuplicate">
                                {{data.pageDuplicateMessage?data.pageDuplicateMessage:"please enter unique name or use
                                older
                                one
                                directly"}}</div>
                            <div class="mat-error ng-star-inserted element"
                                *ngIf="form.get('name').hasError('keyword') || isKeyword">please choose a different name
                            </div>
                            <div class="mat-error ng-star-inserted element"
                                *ngIf="form.get('name').hasError('specialCharacters')">
                                Name must start with _ or a letter and contain only letters, numbers, - or _.
                            </div>
                        </div>
                    </div>
                    <div class="optionForProject" *ngIf="title === 'Create Project' && integrationAvailable">
                        <label>Align with Project Management</label>
                        <mat-slide-toggle [checked]="isWithPMTChecked" (change)="onPMToggleChange($event)"
                            color="accent">
                            {{ isWithPMTChecked ? 'With Project Management' : 'Without Project Management' }}
                        </mat-slide-toggle>
                    </div>
                    <div class="element_btn">
                        <div class="popup_content_footer">
                            <button class="popup_content_footer_btn" *ngIf="showNextButton" type="button" mat-button
                                (click)="onNextClick()">Next</button>
                            <button class="popup_content_footer_btn" *ngIf="!showNextButton" type="submit" mat-button
                                cdkFocusInitial
                                [disabled]="!form.valid || isDuplicate || isKeyword">Save</button>
                            <button class="popup_content_footer_btn" mat-button [mat-dialog-close]>Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>